import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Cloud } from "lucide-react";
import { DirectionsDialog } from "./DirectionsDialog";
import WeatherWidget from "@/components/WeatherWidget";

export function DestinationsDialogs({
  directionsDialogOpen, setDirectionsDialogOpen, directionsDestination,
  directionsOrigin, setDirectionsOrigin, getDirections,
  weatherDialogOpen, setWeatherDialogOpen, selectedDestination,
}) {
  return (
    <>
      <DirectionsDialog open={directionsDialogOpen} onOpenChange={setDirectionsDialogOpen} destination={directionsDestination} origin={directionsOrigin} onOriginChange={setDirectionsOrigin} onGetDirections={getDirections} />

      <Sheet open={weatherDialogOpen} onOpenChange={setWeatherDialogOpen}>
        <SheetContent className="w-full sm:max-w-lg overflow-y-auto">
          <SheetHeader>
            <SheetTitle className="font-serif text-xl flex items-center gap-2"><Cloud className="w-5 h-5 text-accent" />Weather & Fishing Conditions</SheetTitle>
            <SheetDescription>{selectedDestination && <span>{selectedDestination.name}, {selectedDestination.state}</span>}</SheetDescription>
          </SheetHeader>
          <div className="mt-4">{selectedDestination && <WeatherWidget lat={selectedDestination.latitude} lon={selectedDestination.longitude} showForecast={true} />}</div>
        </SheetContent>
      </Sheet>
    </>
  );
}
